import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS, plPL } from '@mui/x-date-pickers/locales';
import enGB from 'date-fns/locale/en-GB';
import pl from 'date-fns/locale/pl';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

function resolveLang(language: string | undefined): 'en' | 'pl' {
  const base = language?.split('-')[0]?.toLowerCase();
  return base === 'en' ? 'en' : 'pl';
}

export default function I18nDateLocalization({ children }: Props) {
  const { i18n } = useTranslation();
  const lang = resolveLang(i18n.resolvedLanguage || i18n.language);
  const adapterLocale = lang === 'en' ? enGB : pl;
  const localeText =
    lang === 'en'
      ? enUS.components.MuiLocalizationProvider.defaultProps.localeText
      : plPL.components.MuiLocalizationProvider.defaultProps.localeText;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
      localeText={localeText}
    >
      {children}
    </LocalizationProvider>
  );
}
